// extracted by mini-css-extract-plugin
export default {"container":"CountryFlag_container__jyiFE"};